import { render, staticRenderFns } from "./wxdzshenhe.vue?vue&type=template&id=68fae374&scoped=true"
import script from "./wxdzshenhe.vue?vue&type=script&lang=js"
export * from "./wxdzshenhe.vue?vue&type=script&lang=js"
import style0 from "./wxdzshenhe.vue?vue&type=style&index=0&id=68fae374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fae374",
  null
  
)

export default component.exports